import React, {useState} from "react";

import {creditCalculatorAnalytics, CreditCalculatorGTMEvent} from "../../tracking/credit_gtm";
import {getCreditEventActionFromCalculatorValueType} from "../../tracking/get_credit_event_action";
import {CalculatorValueType} from "../../types/CalculatorValueType";
import {ICalculatorOptions} from "../../types/ICalculatorOptions";
import {getCalculatorSelectOptions} from "../../utils/get_calculator_select_options";
import {CalculatorBaseInput} from "../calculator_inputs/CalculatorBaseInput";
import {CalculatorSelectInput} from "../calculator_inputs/CalculatorSelectInput";

interface IProps extends ICalculatorOptions {
    price: number;
    period: number;
    contribution: number;
    updateValue: (type: CalculatorValueType, value: number) => void;
    dataTestId?: string;
}

export const CreditOfferFilterInputs = (props: IProps) => {
    const {price, period, contribution, updateValue, valueType, values, step, dataTestId} = props;

    const [gtmEventSend, setGtmEventSend] = useState<boolean>(false);

    const onInvalidValue = (value?: number) => {
        if (valueType === CalculatorValueType.CONTRIBUTION && values.init) {
            updateValue(valueType, value || (values.init * price) / 100 || 0);
            return;
        }
        updateValue(valueType, value || values.init || 0);
    };

    const onValueChange = (type: CalculatorValueType, value: number) => {
        if (!gtmEventSend) {
            const action = getCreditEventActionFromCalculatorValueType(type);
            creditCalculatorAnalytics.gtm.creditCalculatorEvent(CreditCalculatorGTMEvent.CREDIT_INSTALMENT_CALCULATOR, {credit_action: action});
            setGtmEventSend(true);
        }
        updateValue(type, value);
    };

    const onPriceBlur = (value: number, min: number, max: number) => {
        if (value < min) {
            updateValue(CalculatorValueType.CONTRIBUTION, (min * 20) / 100);
            return;
        }
        if (value > max) {
            updateValue(CalculatorValueType.CONTRIBUTION, (max * 20) / 100);
            return;
        }

        if (value < contribution || contribution < (value * 10) / 100 || contribution >= (value * 90) / 100) {
            updateValue(CalculatorValueType.CONTRIBUTION, (value * 20) / 100);
        }
    };

    switch (valueType) {
        case CalculatorValueType.PERIOD:
            const selectOptions = getCalculatorSelectOptions(values, step);
            return <CalculatorSelectInput value={period} valueType={valueType} options={selectOptions} updateValue={onValueChange} dataTestId={dataTestId} />;
        case CalculatorValueType.CONTRIBUTION:
            return (
                <CalculatorBaseInput
                    value={contribution}
                    label="zł"
                    min={values.lower as number}
                    max={values.upper as number}
                    valueType={valueType}
                    updateValue={onValueChange}
                    onInvalidValue={onInvalidValue}
                    convertedPercentBase={price}
                    dataTestId={dataTestId}
                />
            );
        default:
            return (
                <CalculatorBaseInput
                    value={price}
                    label="zł"
                    min={values.lower as number}
                    max={values.upper as number}
                    valueType={valueType}
                    updateValue={onValueChange}
                    onInvalidValue={onInvalidValue}
                    onAfterBlur={onPriceBlur}
                    dataTestId={dataTestId}
                />
            );
    }
};
import React, {useState} from "react";

import {creditCalculatorAnalytics, CreditCalculatorGTMEvent} from "../../tracking/credit_gtm";
import {getCreditEventActionFromCalculatorValueType} from "../../tracking/get_credit_event_action";
import {CalculatorValueType} from "../../types/CalculatorValueType";
import {ICalculatorOptions} from "../../types/ICalculatorOptions";
import {getCalculatorSelectOptions} from "../../utils/get_calculator_select_options";
import {CalculatorBaseInput} from "../calculator_inputs/CalculatorBaseInput";
import {CalculatorSelectInput} from "../calculator_inputs/CalculatorSelectInput";

interface IProps extends ICalculatorOptions {
    price: number;
    period: number;
    contribution: number;
    updateValue: (type: CalculatorValueType, value: number) => void;
    dataTestId?: string;
}

export const CreditOfferFilterInputs = (props: IProps) => {
    const {price, period, contribution, updateValue, valueType, values, step, dataTestId} = props;

    const [gtmEventSend, setGtmEventSend] = useState<boolean>(false);

    const onInvalidValue = (value?: number) => {
        if (valueType === CalculatorValueType.CONTRIBUTION && values.init) {
            updateValue(valueType, value || (values.init * price) / 100 || 0);
            return;
        }
        updateValue(valueType, value || values.init || 0);
    };

    const onValueChange = (type: CalculatorValueType, value: number) => {
        if (!gtmEventSend) {
            const action = getCreditEventActionFromCalculatorValueType(type);
            creditCalculatorAnalytics.gtm.creditCalculatorEvent(CreditCalculatorGTMEvent.CREDIT_INSTALMENT_CALCULATOR, {credit_action: action});
            setGtmEventSend(true);
        }
        updateValue(type, value);
    };

    const onPriceBlur = (value: number, min: number, max: number) => {
        if (value < min) {
            updateValue(CalculatorValueType.CONTRIBUTION, (min * 20) / 100);
            return;
        }
        if (value > max) {
            updateValue(CalculatorValueType.CONTRIBUTION, (max * 20) / 100);
            return;
        }

        if (value < contribution || contribution < (value * 10) / 100 || contribution >= (value * 90) / 100) {
            updateValue(CalculatorValueType.CONTRIBUTION, (value * 20) / 100);
        }
    };

    switch (valueType) {
        case CalculatorValueType.PERIOD:
            const selectOptions = getCalculatorSelectOptions(values, step);
            return <CalculatorSelectInput value={period} valueType={valueType} options={selectOptions} updateValue={onValueChange} dataTestId={dataTestId} />;
        case CalculatorValueType.CONTRIBUTION:
            return (
                <CalculatorBaseInput
                    value={contribution}
                    label="zł"
                    min={values.lower as number}
                    max={values.upper as number}
                    valueType={valueType}
                    updateValue={onValueChange}
                    onInvalidValue={onInvalidValue}
                    convertedPercentBase={price}
                    dataTestId={dataTestId}
                />
            );
        default:
            return (
                <CalculatorBaseInput
                    value={price}
                    label="zł"
                    min={values.lower as number}
                    max={values.upper as number}
                    valueType={valueType}
                    updateValue={onValueChange}
                    onInvalidValue={onInvalidValue}
                    onAfterBlur={onPriceBlur}
                    dataTestId={dataTestId}
                />
            );
    }
};
